import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
export function extend(Runtime, library) {
  var Chart = /*#__PURE__*/function (_Runtime) {
    _inherits(Chart, _Runtime);
    function Chart(options) {
      _classCallCheck(this, Chart);
      return _possibleConstructorReturn(this, _getPrototypeOf(Chart).call(this, Object.assign(Object.assign({}, options), {
        lib: library
      })));
    }
    return Chart;
  }(Runtime);
  return Chart;
}